import { MessageCircle } from "lucide-react";
import { getProductNameFromPath, trackEvent } from "@/lib/analytics";
import { useLocation } from "react-router-dom";

export const FloatingWhatsApp = () => {
  const { pathname } = useLocation();
  const isProductPage = pathname.startsWith("/produk/");

  return (
    <a
      href="/kontak#kontak"
      data-testid="whatsapp-floating-btn"
      onClick={() =>
        trackEvent("whatsapp_float_clicked", {
          category: "contact",
          label: "Floating WhatsApp",
          source: "floating_button",
          product_name: getProductNameFromPath(pathname),
        })
      }
      className="fixed bottom-6 right-6 z-40 group"
    >
      <div className="absolute inset-0 rounded-full bg-animax-orange/40 blur-xl group-hover:blur-2xl transition-all animate-pulse" />
      <div className={`relative flex items-center gap-3 pl-4 pr-5 py-3.5 rounded-full text-white shadow-lg transition-all ${isProductPage ? "bg-animax-orange shadow-animax-orange/30 hover:bg-animax-yellow hover:text-animax-black" : "bg-gradient-to-br from-[#e60012] to-[#ff6873] shadow-red-500/30 hover:brightness-95"}`}>
        <MessageCircle className="w-5 h-5" />
        <span className="text-sm font-medium hidden sm:inline">Hubungi Tim Sales</span>
      </div>
    </a>
  );
};
